export default __webpack_public_path__ + "static/media/nners_raceweek_750_cochemoto_330x330.b9c1ca37.webp";